import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=3353c4d6&scoped=true"
import script from "./Cases.vue?vue&type=script&lang=js"
export * from "./Cases.vue?vue&type=script&lang=js"
import style0 from "./Cases.vue?vue&type=style&index=0&id=3353c4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3353c4d6",
  null
  
)

export default component.exports